import React, { Component } from 'react'
import { Button, Icon, Modal, Spin } from 'antd'
import _ from 'lodash'
import cx from 'classnames'

import './MemberListModal.scss'

export default class MemberListModal extends Component {
    getPMButtonClassname(authorized, deleted) {
        const { isAuthorized } = this.props
        return cx('pm-icon', {
            'active': authorized,
            'disabled': !isAuthorized || deleted
        })
    }

    renderCurrentMemberList() {
        const { currentMemberList, onMemberRemove, onMemberAuthChange, isAuthorized } = this.props

        if (_.isEmpty(currentMemberList))
            return (
                <div className="member-list-loading">
                    <Spin />
                </div>
            )
        else
            return (
                <div className="member-list">
                    <div className="member-name" key={currentMemberList.created_by.member_id}>
                        <span className="pm-icon active">PM</span>
                        { <span className={currentMemberList.created_by.deleted ? 'deleted' : ''}>{currentMemberList.created_by.first_name}</span> }
                    </div>
                    {
                        _.map(currentMemberList.members, (member, idx) => (
                                <div className="member-name" key={member.member_id}>
                                    { 
                                        isAuthorized && !member.deleted ? 
                                        <span className={this.getPMButtonClassname(member.able_to_create, member.deleted)} onClick={onMemberAuthChange.bind(this, member.member_id, member.able_to_create)}>PM</span> :
                                        <span className={this.getPMButtonClassname(member.able_to_create, member.deleted)}>PM</span>
                                    }
                                    { <span className={member.deleted ? 'deleted' : ''}>{member.first_name}</span> }
                                    { isAuthorized && <Icon className="remove-btn" type="close" onClick={onMemberRemove.bind(this, member.member_id)}/> }
                                </div> 
                            )
                        )
                    }
                </div>
            )
    }

    rednerAvailableMemberList() {
        const { onMemberAdd, availableMemberList } = this.props

        if (availableMemberList === undefined)
            return (
                <div className="member-list-loading">
                    <Spin />
                </div>
            )
        else if (availableMemberList.length === 0)
            return (
                <div className="member-list-loading">
                    No member available.
                </div>
            )
        else
            return (
                <div className="member-list">
                    {
                        _.map(availableMemberList, (member, idx) => ( 
                                <div className="member-name" key={member._id}>
                                    <Icon className="add-btn" type="plus" onClick={onMemberAdd.bind(this, member._id)}/>
                                    {member.first_name}
                                </div> 
                            )
                        )
                    }
                </div>
            )
    }

    render() {
        const { visible, onCancel, isAuthorized } = this.props

        return (
            <Modal 
                width="60%"
                wrapClassName="MemberListModal"
                visible={visible}
                footer={null}
                onCancel={onCancel}
            >
                <p>{isAuthorized ? 'You can edit the project members here:' : 'List of project members are shown below:'}</p>
                <div className="current-member-list">
                    {this.renderCurrentMemberList()}
                </div>
                { isAuthorized && <p>You can add new members here:</p> }
                {
                    isAuthorized &&
                    <div className="available-member-list">
                        {this.rednerAvailableMemberList()}
                    </div>
                }
                <div className="footer">
                    <Button type="primary" size="large" onClick={onCancel}>Done</Button>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/MemberListModal/MemberListModal.js